/**
 * Kho bạc điện tử - Hồ sơ đối chiếu số dư
 * nnninh 27/04/2023
 */
export default {
  DCSDFileList: {
    TitleList: 'Hồ sơ đối chiếu số dư',
    Text: {
      UpdateKBNNStatus: 'Kiểm tra trạng thái hồ sơ từ KBNN',
      AdviseSentence: 'Đơn vị nên thiết lập hậu tố khác nhau cho các dữ liệu kế toán có chung mã quan hệ ngân sách ',
    },
  },
  DCSDFileDetail: {
    TitleDetail: 'Thêm mới hồ sơ đối chiếu số dư',
    TitleEdit: 'Sửa hồ sơ đối chiếu số dư',
    TitleView: 'Xem hồ sơ đối chiếu số dư',
    Text: {
      FileCode: 'Mã hồ sơ *',
      StateTreasuryCode: 'Giao dịch tại *',
      CreatedDate: 'Ngày tạo *',
      Viewing: 'Danh sách bảng đối chiếu',
      TitleFile: 'Mô tả *',
      BudgetCode: 'Mã ĐVQHNS đối chiếu *',
    },
    TextTooltip: {
      FileCode: 'Mã hồ sơ',
      StateTreasuryCode: 'Giao dịch tại',
      CreatedDate: 'Ngày tạo',
      TitleFile: 'Mô tả',
      RefreshFileCode: 'Làm mới mã hồ sơ',
      OpenFileDetailSetting: 'Thiết lập quy tắc sinh Mã hồ sơ',
      ChooseReport: 'Chọn mẫu báo cáo',
      ChooseParam: 'Chọn lại tham số',
      BudgetCode: 'Mã đơn vị quan hệ ngân sách đối chiếu',
    },
    Message: {
      SaveError: 'Thêm mới không thành công',
      SendApproveSuccess: 'Gửi duyệt hồ sơ thành công',
      Delete: 'Xóa hồ sơ đối chiếu',
      ChooseReportNo: 'Chưa chọn mẫu báo cáo',
      NoDVQHNS: 'Vui lòng chọn Mã ĐVQHNS đối chiếu trước khi chọn mẫu báo cáo.',
      DeleteReport: 'Xóa báo cáo đối chiếu',
      DeleteReportMsg: 'Bạn có muốn xóa báo cáo {0} không?',
    },
    SaveAndApprove: 'Cất và gửi duyệt',
  },
  DCSDReportB01: {
    DataOptionTitle: 'Tùy chọn lấy số liệu',
    DataReportTitle: 'Lấy số liệu báo cáo',
    All: 'Tất cả',
    Option: 'Tùy chọn',
    SelfTemplate: 'Mẫu tự chủ',
    ShowProjectData: 'Hiển thị số liệu theo CTMTQG',
    GetDataXDCB: 'Lấy số liệu XDCB',
    GetDataPayment: 'Lấy số liệu chi thường xuyên',
    EstimateUsedTitle: 'Dự toán đã sử dụng',
    GetPaymentData: 'Lấy số rút thực chi và số thanh toán tạm ứng',
    GetPaymentRefNo: 'Lấy số rút thực chi và số rút tạm ứng',
    GetSetupFormula: 'Lấy theo công thức tự thiết lập',
  },
  DCSDReportB04: {
    FromYear: 'Từ năm',
    TransferNextYear: 'Chuyển sang'
  },
};
